import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { t } from 'i18next';
import CrudBase from "src/components/CrudBase";
import InvoiceCombineKey from 'src/models/invoiceCombineKey';
import InvoiceCombineKeyForm from './InvoiceCombineKeyForm';

export function InvoiceCombineKeys() {
    return (
        <CrudBase<InvoiceCombineKey>
            resource="invoice-combine-keys"
            indexColumns={['identifier', 'client_rfc', 'client_name', 'expeditor_rfc', 'expeditor_name']}
            showModalColumns={['identifier','description','created_at','updated_at']}
            permissions={{
                'view' : 'invoices.client_config',
                'list' : 'invoices.client_config',
                'create' : 'invoices.client_config',
                'edit' : 'invoices.client_config',
                'delete' : 'invoices.client_config',
            }}
            Form={InvoiceCombineKeyForm}
            deleteButton={true}
            searchInput={true}
            Icon={ManageAccountsIcon} />
    );
}
